import { IconButton, InputBase, Paper } from "@material-ui/core";
import React, { Component } from "react";
import { Button, Modal, Row } from "react-bootstrap";
import Filter from "../../vendorDashboardComponents/offers/Filter";
import SearchIcon from "@material-ui/icons/Search";
import {
  get_menu_items,
  reset_all_sold_out,
} from "../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Alert from "react-s-alert";
import ItemAvailabilityFilter from "./ItemAvailabilityFilter";
class FiltersSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      open: false,
    };
  }

  onSuccess = () => {
    this.props.get_menu_items(this.props.token);
    this.setState({ open: false });
    Alert.success(`<h4>Updated Sucessfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  onSearchChange = (e) => {
    this.setState({
      search: e.target.value,
    });
    this.props.search(e.target.value);
  };
  /** */
  onClickYes = () => {
    this.props.reset_all_sold_out(this.props.token, this.onSuccess, (error) => {
      console.error("Reset operation failed", error);
    });
  };

  render() {
    return (
      <React.Fragment>
        <Row>
          <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 seating-topbar-search">
            <div className="filter-button">
              <ItemAvailabilityFilter
                availabilityData={this.props.availability}
                statusData={this.props.status}
                itemTagsData={this.props.itemTags}
                activeServiceData={this.props.activeService}
                cuisineTypeData={this.props.cuisineType}
              />
            </div>
            <div className="filter-button-border-left"></div>
            <div className="filter-button-search">
              {/* <Form.Control
                    type="text"
                    placeholder="Search"
                    onChange={this.onSearchChange}
                    value={this.state.search}
                    className="amSearch"
                  /> */}
              <Paper component="form" className="enSearch2 d-flex">
                <IconButton type="submit" aria-label="search">
                  <SearchIcon />
                </IconButton>
                <InputBase
                  placeholder="Search"
                  className="w-100"
                  inputProps={{
                    "aria-label": "Search by Name or Phone Number",
                  }}
                  onChange={this.onSearchChange}
                  value={this.state.search}
                />
              </Paper>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 right-side-seating justify-content-end">
            <div align="right">
              <p
                style={{ cursor: "pointer", color: "#2196F3" }}
                onClick={() => {
                  this.setState({ open: true });
                }}
                className="mv-p"
              >
                Reset all to Available
              </p>
            </div>
          </div>
          <div>
            <Modal
              show={this.state.open}
              onHide={() => {
                this.setState({ open: false });
              }}
              centered
              size="md"
            >
              <Modal.Header className="border-0 pl-4" closeButton>
                <Modal.Title className="f24-700">
                  Reset all to Available
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="p-4 f16-400">
                <div className="">
                  Are you sure you want to Reset all to Available items?
                </div>
                <div
                  className="d-flex align-items-center pt-5"
                  style={{ justifyContent: "center" }}
                >
                  <Button
                    style={{ fontSize: "18px" }}
                    variant="outline-secondary"
                    className="mr-4 px-3 py-2"
                    onClick={() => this.setState({ open: false })}
                  //   onClick={(e) => this.props.history.push("/superadminorders")}
                  >
                    No
                  </Button>
                  <Button
                    style={{ fontSize: "18px" }}
                    variant="danger"
                    className="px-3  py-2"
                    onClick={() => this.onClickYes()}
                  //onClick={(e) => handleShowTab("2")}
                  //type="submit"
                  //   onClick={() => onClickStepOne()}
                  >
                    Yes
                  </Button>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </Row>
      </React.Fragment>
    );
  }
}

FiltersSection.propTypes = {
  auth: PropTypes.object.isRequired,
  reset_all_sold_out: PropTypes.func.isRequired,
  get_menu_items: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  get_menu_items,
  reset_all_sold_out,
})(FiltersSection);
